module.exports = __webpack_public_path__ + "img/icon-question-rating-star-hover.e22276f9.svg";